package org.solyton.solawi.bid.module.application.`data`.application

import kotlin.String
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.application.`data`.LifecycleStage
import org.solyton.solawi.bid.module.application.`data`.module.Module

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.id]
 */
@ReadWrite
public val id: Lens<Application, String> by lazy {
      Lens(
        get = { whole -> whole.id },
        set = { part -> { whole -> whole.copy(id = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.id]
 */
@ReadWrite
public fun Application.id(`set`: String.() -> String): Application = copy(id = set(id))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.name]
 */
@ReadWrite
public val name: Lens<Application, String> by lazy {
      Lens(
        get = { whole -> whole.name },
        set = { part -> { whole -> whole.copy(name = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.name]
 */
@ReadWrite
public fun Application.name(`set`: String.() -> String): Application = copy(name = set(name))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.state]
 */
@ReadWrite
public val state: Lens<Application, LifecycleStage> by lazy {
      Lens(
        get = { whole -> whole.state },
        set = { part -> { whole -> whole.copy(state = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.state]
 */
@ReadWrite
public fun Application.state(`set`: LifecycleStage.() -> LifecycleStage): Application = copy(state =
    set(state))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.modules]
 */
@ReadWrite
public val modules: Lens<Application, List<Module>> by lazy {
      Lens(
        get = { whole -> whole.modules },
        set = { part -> { whole -> whole.copy(modules = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.modules]
 */
@ReadWrite
public fun Application.modules(`set`: List<Module>.() -> List<Module>): Application = copy(modules =
    set(modules))
